import React from "react";
import { View, Text, Dimensions } from "react-native";
import i18n from "@microdoing/shared/i18n";
import { connect } from "react-redux";
import Colors from "@microdoing/shared/constants/Colors";
import { getIsConnected } from "@microdoing/shared/services/network/selectors";
import theme from "app/Theme/Theme";

const { width, height } = Dimensions.get("window");

const OfflineNoticeComp = ({ isConnected }) => {
  if (!isConnected) {
    return (
      <View style={styles.offlineContainer}>
        <Text style={styles.offlineText}>{i18n.t("no-connection")}</Text>
      </View>
    );
  }
  return null;
};

const styles = {
  offlineContainer: {
    backgroundColor: Colors.red,
    padding: 5,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    width,
  },
  offlineText: {
    color: theme.colors["neutral.white"],
    fontWeight: "bold",
    fontSize: 12,
  },
};

const mapStateToProps = state => {
  return {
    isConnected: getIsConnected(state),
  };
};

const OfflineNotice = connect(mapStateToProps, null)(OfflineNoticeComp);

export { OfflineNotice };
